import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Phone } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-sorg-beige/30 pt-20 pb-10 px-6 border-t border-sorg-beige">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="col-span-1 md:col-span-1">
          <Link to="/" className="mb-6 block">
            <img 
              src="https://assets.auxodev.dk/assets/88d34a44-1e08-49cc-ba2b-c330133a247e/fecf0b5e-783e-45ee-a1c0-716db9fea84c.png" 
              alt="Sorgskab Logo" 
              className="h-32 w-auto object-contain"
            />
          </Link>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-6 text-sorg-earth">Navigation</h4>
          <ul className="space-y-3">
            <li><Link to="/sorgvejleder" className="text-sorg-dark/70 hover:text-sorg-earth text-sm transition-colors">Sorgsamtaler</Link></li>
            <li><Link to="/dodsdoula" className="text-sorg-dark/70 hover:text-sorg-earth text-sm transition-colors">Dødsdoula</Link></li>
            <li><Link to="/foredrag-workshops" className="text-sorg-dark/70 hover:text-sorg-earth text-sm transition-colors">Foredrag &amp; Workshops</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-6 text-sorg-earth">Kontakt</h4>
          <ul className="space-y-3">
            <li className="flex items-center space-x-3 text-sorg-dark/70 text-sm">
              <Mail size={16} strokeWidth={1} className="text-sorg-earth" />
              <a href="mailto:asha@sorgskab.dk" className="hover:text-sorg-earth transition-colors">asha@sorgskab.dk</a>
            </li>
            <li className="flex items-center space-x-3 text-sorg-dark/70 text-sm">
              <Phone size={16} strokeWidth={1} className="text-sorg-earth" />
              <a href="tel:+4541623552" className="hover:text-sorg-earth transition-colors">+45 41 62 35 52</a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-6 text-sorg-earth">Følg med</h4>
          <div className="flex space-x-4">
            <a href="https://www.instagram.com/Sorgskab.dk" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-sorg-earth hover:bg-sorg-earth hover:text-white transition-all soft-shadow">
              <Instagram size={20} strokeWidth={1} />
            </a>
            <a href="https://www.facebook.com/people/Sorgskabdk/61590255696128/?mibextid=wwXIfr&rdid=sjjeI0CIWQCCGCo6&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1BvfS5ZdNX%2F%3Fmibextid%3DwwXIfr" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-sorg-earth hover:bg-sorg-earth hover:text-white transition-all soft-shadow">
              <Facebook size={20} strokeWidth={1} />
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-20 pt-8 border-t border-sorg-beige flex flex-col md:row justify-between items-center space-y-4 md:space-y-0 text-xs text-sorg-dark/40 tracking-wider uppercase">
        <p>© {new Date().getFullYear()} Sorgskab. Alle rettigheder forbeholdes.</p>
        <div className="flex space-x-6">
          <a href="#" className="hover:text-sorg-earth transition-colors">Privatlivspolitik</a>
          <a href="#" className="hover:text-sorg-earth transition-colors">Handelsbetingelser</a>
        </div>
      </div>
    </footer>
  );
}
